/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { PenIconFilled, TrashIconFilled } from 'shared/components/Icons';
import { DateTime } from 'luxon';
import { addQueryParam } from 'utils/locationHelper';
import { getProjectImgAndShareIcon } from 'utils/projectHelpers';
import { confirmBox } from 'utils/appHelpers';
import { deleteProject } from 'app/routes/Dashboard/actions/projects';
import { useAlert } from 'react-alert';
import { useSelector } from 'react-redux';
import allProjectIcon from 'assets/images/all-projects.jpg';
import ActionButtons from 'shared/components/likiee/ActionButtons';
import AddProjectIcon from 'assets/images/icons/add-new-project.svg';
import AvatarImg from 'shared/components/AvatarImg';
import { getLocalizedPath } from 'utils/languageHelpers';

const Projects = ({ data, isShared, onCreateNewProject, title }) => {
  const { t } = useTranslation();
  const totalLikiees = useSelector(state => state.home?.totalLikiees);
  const alert = useAlert();
  const history = useHistory();

  const goToProducts = item => {
    if (isShared) {
      history.push(getLocalizedPath(`/user/${item.owner}/project/${item.id}`));
    } else {
      history.push(getLocalizedPath(`/likiees/project/${item.id || ''}`));
    }
  };

  const onOpenUserPage = (item, e) => {
    e.stopPropagation();
    history.push(getLocalizedPath(`/user/${item.user.id}`));
  };

  const allLikiessProject = {
    isAllItems: true,
    name: t('text_all_likiees'),
    itemsCount: totalLikiees || 0,
    icon: allProjectIcon,
  };

  const getDiffDate = updatedAt => {
    const updatedAtTime = DateTime.fromISO(updatedAt);
    const diffDate = DateTime.now().diff(updatedAtTime, ['day', 'week']);
    const weeks = diffDate.weeks.toFixed();
    const days = diffDate.days.toFixed();
    return weeks > 0
      ? `${weeks} ${t('text_weeks', { count: weeks })}`
      : days < 1
      ? t('text_today')
      : `${days} ${t('text_days', { count: days })}`;
  };

  const result = isShared ? data : [allLikiessProject, ...data];

  const handleProjectModalOpen = (id, e) => {
    history.push(addQueryParam('pj', id));
    e.stopPropagation();
  };

  const onProjectRemove = (item, e) => {
    const options = {
      onSuccess: async () => {
        await deleteProject(item);
        alert.success(t('msg_success_project_remove'));
      },
      title: t('project_remove_title'),
      message: t('project_remove_text'),
      cancel: t('btn_cancel'),
      confirm: t('btn_confirm'),
    };
    confirmBox(options);
    e.stopPropagation();
  };

  return (
    <div className='mb-15 project-items'>
      {title && <h1 className='mb-8 mb-md-12'>{title}</h1>}
      <div className='d-flex row flex-wrap px-4 px-md-0'>
        {result.map((item, i) => {
          const { Icon, image, isNoImage } = getProjectImgAndShareIcon(item);

          const actionButtons = [
            { logo: <PenIconFilled />, onClick: handleProjectModalOpen.bind(null, item.id) },
            { logo: <TrashIconFilled />, onClick: onProjectRemove.bind(null, item) },
          ];

          return (
            <div key={i} className='project-block cursor-pointer' onClick={goToProducts.bind(null, item)}>
              <div className={`project-image ${isNoImage ? 'no-image' : ''}`}>
                {item.visibility && !isShared && (
                  <div className='left-corner action-btn'>
                    <Icon />
                  </div>
                )}
                {item.user?.picture && isShared && (
                  <div
                    className='left-corner action-btn rounded-100p overflow-hidden border-2 border border-light'
                    onClick={onOpenUserPage.bind(null, item)}
                  >
                    <AvatarImg width='36px' height='36px' picture={item.user.picture} name={item.user.name} />
                  </div>
                )}
                <div className='d-flex flex-column justify-content-center align-items-center h-100 lh-initial'>
                  <img src={image} alt={item.name} />
                </div>
                {!isShared && !item.isAllItems && <ActionButtons buttons={actionButtons} />}
              </div>
              <div className='project-info mt-5 mt-md-8'>
                <p className='mb-3 mb-md-6 text-lg fw-500'>{item.name}</p>
                <p className='mb-0 text-gray-dark fw-300 d-flex justify-content-between'>
                  <span>
                    {item.itemsCount} {t('text_products')}
                  </span>
                  {item.updatedAt && <span>{getDiffDate(item.updatedAt)}</span>}
                </p>
              </div>
            </div>
          );
        })}
        {onCreateNewProject && (
          <div className='project-block cursor-pointer' onClick={onCreateNewProject}>
            <div className='project-image new-project d-flex flex-column align-items-center justify-content-center no-image pt-5'>
              <img src={AddProjectIcon} alt='add-new' width='120' />
              <p className='mt-8 mb-0'>{t('text_add_new_project')}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;
